import React from "react";
import { proofStats } from "../../content/siteContent";
import { Reveal } from "../motion/Reveal";

export const CredibilityStrip = () => (
  <section data-testid="credibility-strip" className="bg-navy-2 border-y border-hair-dark">
    <div className="container-page">
      <div className="grid grid-cols-2 md:grid-cols-5 divide-x divide-y md:divide-y-0 divide-[rgba(246,248,250,0.12)] border-x border-[rgba(246,248,250,0.12)]">
        {proofStats.map((s, i) => (
          <Reveal
            key={s.label}
            delay={i * 0.06}
            className="px-6 py-8 lg:py-10"
          >
            <div className="flex items-baseline gap-1">
              <span className="font-display font-extrabold text-3xl lg:text-4xl text-white tracking-tight">
                {s.value}
              </span>
              {s.suffix && (
                <span className="font-display font-semibold text-sm text-teal">{s.suffix}</span>
              )}
            </div>
            <p className="mt-2 text-white/60 text-xs lg:text-sm leading-snug">{s.label}</p>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
